import React, { useEffect, useState } from 'react';
import { IGetApiType, IShowFormComponent } from '../../interfaces';
import { useRouterStore } from '../../hooks';
import {
    abortSelectedFetch,
    cleanRateRelationSelect,
    cleanRateStore,
    getRateEditRelationSelect,
    getRateShowRelationSelect,
    getRateV22,
} from '../../middleware';
import { Catcher } from '../Catcher';
import { EditRateFormsV2, ShowRate } from './Components';

export const SalesRateListV2: React.FC<IShowFormComponent> = ({ isEdit, isNew }: IShowFormComponent) => {
    const routerStore = useRouterStore();
    const [id, setId] = useState('');
    const usedApiTypes: IGetApiType[] = [
        'DELETE_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2',
        'DELETE_SALES_RATE_LIST_ENTRIES_V2',
        'GET_COUNTRIES_LIST',
        'GET_COUNTRIES_SELECT',
        'GET_CURRENCY_SELECT',
        'GET_NETWORKS_SELECT',
        'GET_OPERATORS_SELECT',
        'GET_OPERATORS_SELECT_ALL',
        'GET_SALES_RATE_LIST_V2',
        'GET_ZONE_SELECT',
        'POST_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2',
        'POST_SALES_RATE_LIST_ENTRIES_V2',
        'PUT_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2',
        'PUT_SALES_RATE_LIST_ENTRIES_V2',
    ];

    useEffect(() => {
        return (): void => {
            abortSelectedFetch(usedApiTypes);
            cleanRateStore();
            cleanRateRelationSelect();
        };
    }, []);

    useEffect(() => {
        const { params } = routerStore.routerState;
        if (params.id) {
            setId(params.id);
        }
    });

    const _getRate = async (id: string): Promise<void> => {
        const isGetRate = await getRateV22(id);
        if (!isGetRate) {
            await routerStore.goTo('SalesRateListsV2');
        }
    };

    const getData = async (id: string): Promise<void> => {
        if (isEdit || isNew) {
            await getRateEditRelationSelect();
        } else {
            await getRateShowRelationSelect();
        }
        _getRate(id);
    };

    useEffect(() => {
        if (!isEdit && !isNew && id) {
            getData(id);
        } else if (!!id === !isNew) {
            getData(id);
        }
    }, [isEdit, isNew, id]);

    const setEdit = async (isEdit?: boolean): Promise<void> => {
        if (isNew) {
            await routerStore.goTo('SalesRateListsV2');
        } else if (isEdit) {
            await getRateEditRelationSelect();
            await _getRate(id);
            await routerStore.goTo('SalesRateListEditV2', { params: { id } });
        } else {
            await getRateShowRelationSelect();
            await _getRate(id);
            routerStore.goBack();
        }
    };

    return (
        <Catcher>
            {isEdit || isNew ? (
                <EditRateFormsV2 setEditMode={setEdit} isNew={isNew} loadingTypes={usedApiTypes} />
            ) : (
                <ShowRate setEditMode={setEdit} isV2 />
            )}
        </Catcher>
    );
};
